import { render, staticRenderFns } from "./week-table.vue?vue&type=template&id=511e9b59&"
import script from "./week-table.vue?vue&type=script&lang=js&"
export * from "./week-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports